import { render, staticRenderFns } from "./BasicDialog.vue?vue&type=template&id=070d2d16&scoped=true"
import script from "./BasicDialog.vue?vue&type=script&lang=ts"
export * from "./BasicDialog.vue?vue&type=script&lang=ts"
import style0 from "./BasicDialog.vue?vue&type=style&index=0&id=070d2d16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070d2d16",
  null
  
)

export default component.exports